document.addEventListener('DOMContentLoaded', function() {
  let slides = document.querySelectorAll('.custom-slider .slide');
  let currentSlide = 0;

  function showSlide(index) {
    slides.forEach(slide => {
      slide.classList.remove('prev', 'active');
    });

    // Set the current slide to 'prev' before moving to the next one
    slides[currentSlide].classList.add('prev');
    
    // Update currentSlide to the new index and add 'active' class to the new slide
    currentSlide = (index + slides.length) % slides.length;
    slides[currentSlide].classList.add('active');
  }

  // Auto slide every 3 seconds
  let slideInterval = setInterval(function() {
    showSlide(currentSlide + 1);
  }, 5000);

  // Arrow navigation
  document.querySelector('.prev-arrow').addEventListener('click', function() {
    clearInterval(slideInterval); // Stop auto slide on manual navigation
    showSlide(currentSlide - 1);
  });

  document.querySelector('.next-arrow').addEventListener('click', function() {
    clearInterval(slideInterval); // Stop auto slide on manual navigation
    showSlide(currentSlide + 1);
  });

  // Initialize the first slide
  showSlide(currentSlide);
});
